module.exports = __webpack_public_path__ + "img/4.64d17c68.png";